var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("side-panel", {
    on: { close: _vm.close },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h3", { staticClass: "mt-0 clearfix" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Service email")) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { attrs: { id: "onboarding" } },
              [
                _c("h1", { staticClass: "my-4" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Bienvenue sur le service email")))
                ]),
                _vm._v(" "),
                _c("email-onboarding-provider", {
                  on: { validProvider: _vm.onValidProvider }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }